<template>
    <div class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-50 tw-bg-white">
        <img src="/preloaders/1490.gif" alt="preloader">
    </div>
</template>

<script setup lang="ts">
</script>

<style scoped>

</style>